const DojoAbstractTransactionCreateRequestRecord = require('./DojoAbstractTransactionCreateRequestRecord');

class DojoTransactionSaleRequestRecord extends DojoAbstractTransactionCreateRequestRecord {
    /**
     * @param {DojoConfig} config
     * @param {} payload
     */
    constructor(config, payload) {
        super(
            config,
            payload,
            'SALE'
        );
    }
}

module.exports = DojoTransactionSaleRequestRecord;
